module.exports = __webpack_public_path__ + "static/media/index.95e0e842.mjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/normalize-svg-path/index.mjs
// module id = 2317
// module chunks = 0